import client from './client';
import type { ApiResponse, Template } from '../types';

interface CreateTemplateRequest {
  name: string;
  subject: string;
  text?: string;
  html?: string;
  envelope_sender?: string;
  category?: string;
  difficulty?: string;
  impersonated_brand?: string;
  attack_vector?: string;
}

export interface TemplateLibraryParams {
  category?: string;
  difficulty?: string;
  vector?: string;
  q?: string;
}

export interface TemplateFacets {
  categories: string[];
  difficulties: string[];
  vectors: string[];
}

export const templatesApi = {
  getAll: () =>
    client.get<Template[]>('/templates/'),

  getLibrary: (params?: TemplateLibraryParams) =>
    client.get<Template[]>('/templates/library', { params }),

  getFacets: () =>
    client.get<TemplateFacets>('/templates/facets'),

  getById: (id: number) =>
    client.get<Template>(`/templates/${id}`),

  create: (data: CreateTemplateRequest) =>
    client.post<Template>('/templates/', data),

  update: (id: number, data: Partial<CreateTemplateRequest>) =>
    client.put<Template>(`/templates/${id}`, { ...data, id }),

  delete: (id: number) =>
    client.delete<ApiResponse<null>>(`/templates/${id}`),

  importBuiltIn: () =>
    client.post<{ created_emails: number; created_pages: number; skipped: number; errors?: string[] }>('/templates/import', {}),
};
